import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Download, Gift } from 'lucide-react';
import voucherImg from '@/assets/voucher.jpg';

const VoucherSection = () => {
  const { t } = useLanguage();

  return (
    <section id="voucher" className="py-20 md:py-32 px-4">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <Gift className="mx-auto text-primary mb-4" size={40} />
          <h2
            className="text-5xl md:text-7xl tracking-wider text-foreground"
            style={{ fontFamily: 'Bebas Neue' }}
          >
            {t.voucher.title}
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <p className="text-foreground/80 leading-relaxed">{t.voucher.text1}</p>
            <p className="text-foreground/80 leading-relaxed">{t.voucher.text2}</p>
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a
                href={voucherImg}
                download="Tom-Art-Mask-Voucher.jpg"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground font-bold uppercase tracking-widest text-sm hover:bg-primary/90 transition-colors rounded-sm"
              >
                <Download size={18} />
                {t.voucher.download}
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <img
              src={voucherImg}
              alt="Tom Art Mask Voucher"
              className="w-full rounded-sm border border-border/50 shadow-lg"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default VoucherSection;
